import { gql } from '@apollo/client'

const EDIT_SHIPPING_ADDRESS = gql`
  mutation EditShippingAddress($storeOrderId: String, $shippingAddress: AddressInput) {
    editShippingAddress(storeOrderId: $storeOrderId, shippingAddress: $shippingAddress) {
      id
    }
  }
`

const EDIT_BILLING_ADDRESS = gql`
  mutation EditBillingAddress($storeOrderId: String, $billingAddress: AddressInput) {
    editBillingAddress(storeOrderId: $storeOrderId, billingAddress: $billingAddress) {
      lineOne
    }
  }
`

export { EDIT_SHIPPING_ADDRESS, EDIT_BILLING_ADDRESS }
